import { render, staticRenderFns } from "./ErroNaoAutorizado.vue?vue&type=template&id=2e8a1a54&"
import script from "./ErroNaoAutorizado.vue?vue&type=script&lang=js&"
export * from "./ErroNaoAutorizado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports